export default {
  WHITE: '#ffffff',
  BLACK: '#000000',
  PURPLE: '#641083',
}
